export default "__VITE_ASSET__002eafb6__"